export const LOB_LIST = 'LOB_LIST'
export const CREATE_LOB = 'CREATE_LOB'
export const EDIT_LOB = 'EDIT_LOB'